// React
import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

// Packages
import { AnimatePresence } from 'framer-motion';

// Project Imports
import { scrollToTopOf } from 'util';
import { HOME, ABOUT_US, OUR_WORK, VIDEOS, SERVICE, ESTIMATE, PRODUCTS } from 'routes';
import {
	AboutPage,
	EstimateRequestPage,
	BrowsePortfolioPage,
	HomePage,
	ServiceTemplatePage,
	BrowseVideosPage,
	PortfolioItemTemplatePage,
	Product,
	Products
} from './components';

export default function AnimatedRoutes() {
	const location = useLocation();

	return (
		// DEV NOTE --> View animations can be adjusted in 'src/util/framerMotion.js' file.
		<AnimatePresence exitBeforeEnter onExitComplete={() => scrollToTopOf('app')}>
			<Routes location={location} key={location.pathname}>
				<Route exact path={HOME} element={<HomePage />} />
				<Route exact path={ABOUT_US} element={<AboutPage />} />
				<Route path={`${SERVICE}/:slug`} element={<ServiceTemplatePage />} />
				<Route exact path={VIDEOS} element={<BrowseVideosPage />} />
				<Route exact path={OUR_WORK} element={<BrowsePortfolioPage />} />
				<Route path={`${OUR_WORK}/:slug`} element={<PortfolioItemTemplatePage />} />
				<Route exact path={ESTIMATE} element={<EstimateRequestPage />} />
				<Route exact path={`${PRODUCTS}/:slug`} element={<Product />} />
				<Route exact path={PRODUCTS} element={<Products />} />
			</Routes>
		</AnimatePresence>
	);
}
